<div [class]="'toaster ' + toasterClass" [checkoutCy]="'notification_' + notification.topic">
    <div class="icon">
        <i class="tri-infos-circle" aria-hidden="true"></i>
    </div>
    <div class="body">
        <p class="text is-level-1">
            <strong>{{ notification.title }}</strong>
        </p>
        <p class="text is-level-2">
            {{ notification.content }}
        </p>
    </div>
    <span (click)="hideNotification()" class="icon is-small toaster-close">
        <i class="tri-times" aria-hidden="true"></i>
    </span>
</div>
